import { render } from "./CProviderForm.vue?vue&type=template&id=b0872d6a"
import script from "./CProviderForm.vue?vue&type=script&lang=js"
export * from "./CProviderForm.vue?vue&type=script&lang=js"

import "./CProviderForm.vue?vue&type=style&index=0&id=b0872d6a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__